const $$splitComponentImporter = () => import('/src/src/routes/_cms/cms/manage/publication_requests/$publicationRequestId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_cms/cms/manage/publication_requests/$publicationRequestId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Publication Request",
      description: "Page title for CMS publication request detail"
    })
  }
});